// extracted by mini-css-extract-plugin
export default {"productDescription":"_aa-z","featuredDescription":"aba-z","description":"bba-z","more":"cba-z","descriptionSku":"dba-z"};